import React, {PropTypes } from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import Briefcase from '../../../components/svg/briefcase';
import Heart from '../../../components/svg/heart';
import Sun from '../../../components/svg/sun';
import Utils from '../../../frilans-finans/utils/utils';

export class Benefit extends React.Component {

  static propTypes = {
    type: PropTypes.string.isRequired,
    user: PropTypes.object
  };

  render () {
    let text;
    let link = '/settings/salary-information';
    let linkText = '';
    let icon = null;
    let target = '_self';
    let primaryValue = 0;
    let secondaryValue = 0;
    let amountTrailing = 'SEK';

    if (this.props.type === 'vacation') {
      text = <Translate content='SAVED_VACATION'/>;
      icon = <Sun width='42' height='42' colorSchema='primary' />;
      primaryValue = this.props.user.vacationPayGross;
      secondaryValue = this.props.user.vacationPay;
      link = 'settings/salary-information';
      linkText = 'POINTS_AND_SAVINGS_LINK_VACATION';
    } else if (this.props.type === 'bonus') {
      text = <Translate content='EARNED_REWARD_POINTS' />;
      icon = <Heart width='42' height='42' colorSchema='primary' />;
      primaryValue = this.props.user.loyaltyPoints;
      link = 'economy/loyalty-program/points';
      linkText = 'POINTS_AND_SAVINGS_LINK_TOGETHER_REWARDS';
      amountTrailing = <Translate content='REWARD_POINTS' />;
    } else {
      text = <Translate content='SAVED_PENSION'/>;
      icon = <Briefcase width='42' height='42' colorSchema='primary' />;
      primaryValue = this.props.user.itp;
      link = 'https://www.frilansfinans.se/fragor-och-svar/tjanstepension/';
      linkText = 'POINTS_AND_SAVINGS_LINK_PENSION';
      target = '_blank';
    }

    const renderSecondaryValue = () => secondaryValue
      ? (<p className='benefit-sum secondary'>
        {Utils.numberWithSpaces(Utils.floor(secondaryValue))} {amountTrailing}&nbsp;
        <Translate content='AFTER_TAX' className='lower-case' />
      </p>)
      : null;

    return (
      <Link
        className='benefit-icon'
        to={link}
        target={target}
        >
        <div className='benefit'>
          {icon}
          <div className='benefit-text'>
            <p className='benefit-sum'>{Utils.numberWithSpaces(Utils.floor(primaryValue))} {amountTrailing}</p>
            {renderSecondaryValue()}
            <p className='benefit-description'>{text}</p>
            <Translate content={linkText} />
          </div>
        </div>
      </Link>
    );
  }
}

export default Benefit;



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/benefit/benefit.js
 **/